import React, { useEffect, useState, useCallback } from "react"
import { useLocation } from "react-router-dom"
import "./NotificationStyle.css"
import { useDispatch, useSelector } from "react-redux"
import { getNotification, getTeacherNotification } from "store/actions"
import moment from "moment"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import { debounce } from "lodash"
import Student from "./Student"
const Notifications = () => {
  const group_id = localStorage.getItem("group_id")
  const dispatch = useDispatch()
  const location = useLocation()

  const { NotificationList, Loading } = useSelector(
    state => state.NotificationReducer
  )

  useEffect(() => {
    if (location.state && location.state.type === 2) {
      setTeacherNotiType(2)
    }
  }, [location])

  const [teacherNotiType, setTeacherNotiType] = useState(1)
  const [searchText, setSearchText] = useState("")
  const [filteredNotifications, setFilteredNotifications] = useState([])

  const dates = new Set()

    const renderDate = dateNum => {
    if (dates.has(moment.utc(dateNum).format("DD/MM/YYYY"))) return null // Prevent duplicates

    dates.add(moment.utc(dateNum).format("DD/MM/YYYY")) // Store date in UTC format

    const returnDate = timestamp => {
      return moment.utc(timestamp).format("DD/MM/YYYY") // Ensure no timezone shift
    }


    return (
      <div className="my-2 d-flex justify-content-center align-items-center">
        <div className="p-2 mb-1 bg-white d-inline-block border rounded-4 shadow">
          {returnDate(dateNum)}
        </div>
      </div>
    )
  }

  useEffect(() => {
    const groupID = localStorage.getItem("group_id")
    if (groupID) {
      if (groupID == 2) {
        dispatch(getNotification())
      } else {
        dispatch(getTeacherNotification(teacherNotiType))
      }
    } else {
      toast.error("Group id not found")
    }
  }, [dispatch, teacherNotiType])

  const debouncedSearch = useCallback(
    debounce((query, list) => {
      const filtered = list.filter(notif =>
        JSON.stringify(notif).toLowerCase().includes(query.toLowerCase())
      )
      setFilteredNotifications(filtered)
    }, 300),
    []
  )

  useEffect(() => {
    if (Array.isArray(NotificationList)) {
      debouncedSearch(searchText, NotificationList)
    }
  }, [searchText, NotificationList, debouncedSearch])

  return (
    <div className="page-content bg-white">
      {localStorage.getItem("group_id") &&
        localStorage.getItem("group_id") != 2 && (
          <div
            className="fixed-top mb-3"
            style={{ zIndex: 1, marginTop: "75px", overflow: "hidden" }}
          >
            <div className="row text-center px-3">
              <div
                className={`col-6 btn ${
                  teacherNotiType == 1 ? " bg-primary text-white" : "bg-light"
                } `}
                onClick={() => setTeacherNotiType(1)}
              >
                Inbox
              </div>
              <div
                className={`col-6 btn ${
                  teacherNotiType == 2 ? " bg-primary text-white" : "bg-light"
                }`}
                onClick={() => setTeacherNotiType(2)}
              >
                Sent
              </div>
            </div>
          </div>
        )}

      {group_id == 2 && (
        <div className="notification_search mb-3 position-sticky top-0 bg-white z-3 p-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
        </div>
      )}
      <Student
        filteredNotifications={filteredNotifications}
        Loading={Loading}
      />
      {localStorage.getItem("group_id") &&
      localStorage.getItem("group_id") != 2 ? (
        <div className="fixed-bottom" style={{ zIndex: 0, marginBottom: "6%" }}>
          <Link
            to={"/create-notifications"}
            className="btn btn-primary btn-rounded mb-5 me-3 btn-lg float-end"
            color="primary"
          >
            New Notification{" "}
          </Link>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default Notifications
